// Tiny utility for tracking who referred a visitor before they sign up.
// Captures ?invited_by={userId} from any URL on the first visit and remembers it
// (along with the movie/party context the visitor landed on) in localStorage so
// the Register form can attribute the sign-up later.

const KEY = "jju_invited_by";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureInviterFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("invited_by");
    if (!id || !/^[0-9a-fA-F]{24}$/.test(id)) return;

    const payload = { id, t: Date.now() };
    // Detect movie context: visitor landed on /cinema/:movieId
    const pathMatch = window.location.pathname.match(/^\/cinema\/([0-9a-fA-F]{24})/);
    if (pathMatch) payload.movie_id = pathMatch[1];
    const party = params.get("party");
    if (party && /^[0-9a-fA-F]{24}$/.test(party)) payload.party_id = party;

    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function getStoredInviter() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj?.id || !obj?.t) return null;
    if (Date.now() - obj.t > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return obj; // { id, t, movie_id?, party_id? }
  } catch {
    return null;
  }
}

export function clearStoredInviter() {
  if (typeof window === "undefined") return;
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
